import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'

import JoinCampButton from '../CampParts/HeaderParts/JoinCampButton'

export default class extends React.Component {
    static propTypes = {
		feedLength: PropTypes.number.isRequired,
		camps: PropTypes.array.isRequired,
	};

    getButton = (camp) => {
		let {ID, status, editing, visibility} = camp
		return <JoinCampButton ID={ID} status={status} editing={editing} visibility={visibility} feedLength={this.props.feedLength} />
	};

    render() {

		return (
			<div id={ !!this.props.camps.length ? "suggestedCamps" : "" }>

				<h3 className="mtop0">Recommended Camps</h3>
				<p>Here are some recommended camps based on your interests. Join camps, say hi, get and share some advice.</p>

				<div className="row ptop30 pbot40">

					{ this.props.camps.map(camp => {

						return <div className="col-sm-3 col-xs-6 text-center recommended-camp" key={'recommended-camps-' + camp.ID}>
							<div className="profile-image mbot20" style={{ backgroundImage: 'url(' + camp.cover_banner + ')', backgroundPosition: '0%' }} />
							<p className="mbot15 camp-title"><strong>
								<Link to={camp.link}>{camp.title}</Link>
							</strong></p>
							<p className="mbot15 camp-description text-mid-gray small">{camp.description}</p>
							{ this.getButton(camp) }
			    		</div>

					})}

	    		</div>

    		</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Community/DashboardParts/RecommendedCamps.jsx